<script setup lang="ts">
/**
 * Picks one of the two layouts `FND-11` calls for, or the sign-in layout, which
 * is signed out but has a design of its own.
 *
 * A single component switching on `route.meta.layout`, rather than nested layout
 * routes. Nesting would put the choice in the route table, where a screen added
 * under the wrong parent silently gets the wrong chrome; here it follows from the
 * screen's own access rule in the catalog and there is nothing to get wrong.
 */

import { computed } from 'vue'
import { useRoute } from 'vue-router'

import AuthenticatedShell from './components/shell/AuthenticatedShell.vue'
import PublicShell from './components/shell/PublicShell.vue'
import SignInShell from './components/shell/SignInShell.vue'

const route = useRoute()
const layout = computed(() => route.meta.layout)
</script>

<template>
  <AuthenticatedShell v-if="layout === 'authenticated'" />
  <SignInShell v-else-if="layout === 'sign-in'" />
  <PublicShell v-else />
</template>
